<template>
  <page>
    <div>
                <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Report Type</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-flex xs12 sm6 xs6>
                  <v-autocomplete
                    :items="pcRptTypes"
                    v-model="reportForm.pcRptType"
                    :label="labels.pcRptType"
                    item-text="label"
                    item-value="value"
                    :error-messages="errors.collect('reportForm.pcRptType')"
                    data-vv-name="reportForm.pcRptType"
                    :data-vv-as="labels.pcRptType"
                    @change="clearForm()"
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
      <v-card>
        <v-card-title primary-title>
        </v-card-title>
        <v-card-text>
          <form>
            <message :messages="messages"></message>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12 sm6 xs6>
                  <cal-picker
                    v-model="reportForm.date"
                    :label="labels.date"
                    v-validate="'required'"
                    :data-vv-as="labels.date"
                    data-vv-name="date"
                    :error-messages="errors.collect('date')"
                    :max="new Date()"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="reportForm.branch"
                    :label="labels.branch"
                    :error-messages="errors.collect('branch')"
                    data-vv-name="branch"
                    :data-vv-as="labels.branch"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('branch')"
                    v-validate="'required'"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="reportForm.dept"
                    :label="labels.dept"
                    :error-messages="errors.collect('dept')"
                    data-vv-name="dept"
                    :data-vv-as="labels.dept"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('dept')"
                    v-validate="'required'"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="reportForm.clmNo"
                    :label="labels.clmNo"
                    :error-messages="errors.collect('clmNo')"
                    data-vv-name="clmNo"
                    :data-vv-as="labels.clmNo"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('clmNo')"
                    v-validate="'required'"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="reportForm.inter"
                    :label="labels.inter"
                    :error-messages="errors.collect('inter')"
                    data-vv-name="inter"
                    :data-vv-as="labels.inter"
                    append-icon="mdi-magnify"
                    @click:append="getHelpList('inter')"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-checkbox v-model="reportForm.coinsPercent" :label="labels.coinsPercent" primary hide-details />
                </v-flex>
              </v-layout>
            </v-container>
          </form>
          <v-dialog v-model="showClmHelpList" width="1280px">
            <claim-help-list :menu="menu" @close="showClmHelpList = false" @doAssign="doAssign($event)"></claim-help-list>
          </v-dialog>
          <v-dialog v-model="showDeptHelpList" width="1080px">
            <dept-help-list :menu="menu" @close="showDeptHelpList = false" @doAssign="doAssign($event)"></dept-help-list>
          </v-dialog>
          <v-dialog v-model="showBranchHelpList" width="1080px">
            <branch-help-list :menu="menu" @close="showBranchHelpList = false" @doAssign="doAssign($event)"></branch-help-list>
          </v-dialog>
          <v-dialog v-model="showIntermediaryHelpList" width="1080px">
            <intermediary-help-list :menu="menu" @close="showIntermediaryHelpList = false" @doAssign="doAssign($event)"></intermediary-help-list>
          </v-dialog>
        </v-card-text>
      </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
                <v-flex xs12 class="pt-3">
                  <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                    <v-icon left dark>mdi-file-export</v-icon>
                    {{ labels.export }}
                  </v-btn>
                  <v-btn-toggle dense mandatory v-model="reportForm.format">
                    <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                      <span>{{ format.label }}</span>
                      <v-icon :color="format.color">{{ format.icon }}</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-flex>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import ClaimHelpList from './ClaimHelpList'
import DeptHelpList from './DeptHelpList'
import BranchHelpList from './BranchHelpList'
import IntermediaryHelpList from './IntermediaryHelpList'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Reprint Claims RI Advice',
          icon: 'mdi-file-chart',
          iconColor: 'primary',
          params: { name: 'clmRIAdviceReprint' }
        }
      ],
      labels: {
        date: 'Entered on*',
        branch: 'Branch*',
        dept: 'Department*',
        clmNo: 'Claim No.*',
        inter: 'Suppress Intermediary',
        coinsPercent: 'Coins % from Policy Master',
        format: 'Export Format',
        export: 'Export To',
        pcRptType: 'Type of Report'
      },
      reportForm: {
        date: undefined,
        branch: 'All',
        dept: 'All',
        clmNo: undefined,
        inter: undefined,
        coinsPercent: false,
        format: undefined,
        pcRptType: 'P'
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      showBranchHelpList: false,
      showDeptHelpList: false,
      showClmHelpList: false,
      showIntermediaryHelpList: false,
      pcRptTypes: [
        { label: 'Print', value: 'P' },
        { label: 'Reprint', value: 'R' }
      ],
      panel: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.claimReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.reportForm.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      if (this.$store.state.reports.claimReports.init !== 1) {
        await this.$store.dispatch('claimReportsInit')
      }
      const apiURI = this.rptMenu.clmRIAdvice
      const result = await this.$http.get(apiURI)
      if (result.data) {
        const { data } = result
        if (data) {
          this.supportedFormat = data.data.format
          this.menu = extractMenu(result.data._links)
        }
      } else {
        this.errorMessage('Failed to retrieve report API url')
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.reportForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClose(rptKeys) {
      if (rptKeys !== undefined && rptKeys !== null) {
        JSON.parse(rptKeys, (key, value) => {
          if (key === 'format') {
            this.reportForm.format = value
          }
        })
      }
    },
    getHelpList(fieldName) {
      if (fieldName === 'clmNo') {
        this.showClmHelpList = true
      }
      if (fieldName === 'branch') {
        this.showBranchHelpList = true
      }
      if (fieldName === 'dept') {
        this.showDeptHelpList = true
      }
      if (fieldName === 'inter') {
        this.showIntermediaryHelpList = true
      }
      this.filterList = true
    },
    doAssign(data) {
      if (this.showBranchHelpList) {
        this.reportForm.branch = data.finalSelectedItems.toString()
        this.$validator.validate('branch')
      }
      if (this.showDeptHelpList) {
        this.reportForm.dept = data.finalSelectedItems.toString()
        this.$validator.validate('dept')
      }
      if (this.showClmHelpList) {
        this.reportForm.clmNo = data.finalSelectedItems.toString()
        this.$validator.validate('clmNo')
      }
      if (this.showIntermediaryHelpList) {
        this.reportForm.inter = data.finalSelectedItems.toString()
      }
      this.showBranchHelpList = false
      this.showDeptHelpList = false
      this.showClmHelpList = false
      this.showIntermediaryHelpList = false
    },
    doCloseFilter() {
      this.filterList = false
    }
  },
  components: {
    ClaimHelpList,
    BranchHelpList,
    DeptHelpList,
    IntermediaryHelpList
  },
  created() {
    this.doInit()
  },
  mixins: [MessageMixin]
}
</script>

<style lang="scss">
</style>
